// extracted by mini-css-extract-plugin
export var wrapper = "SliderButton-module--wrapper--fc863";
export var arrowIcon = "SliderButton-module--arrowIcon--57a1b";
export var white = "SliderButton-module--white--28f6a";